/* DIVAS — interacción del tema (Shopify nativo) */
(() => {
  "use strict";

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

  /* ---------- dinero ---------- */
  const MONEY_FORMAT = (window.Shopify && Shopify.money_format) || "${{amount}}";

  function formatWithDelimiters(cents, precision = 2, thousands = ",", decimal = ".") {
    if (cents == null || isNaN(cents)) return "0";
    const fixed = (Number(cents) / 100).toFixed(precision);
    const [whole, fraction] = fixed.split(".");
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return fraction ? `${grouped}${decimal}${fraction}` : grouped;
  }

  function money(cents) {
    const precision = Number(cents) % 100 === 0 ? 0 : 2;
    const placeholder = (MONEY_FORMAT.match(/\{\{\s*(\w+)\s*\}\}/) || [])[1] || "amount";
    const value = {
      amount: () => formatWithDelimiters(cents, precision),
      amount_no_decimals: () => formatWithDelimiters(cents, 0),
      amount_with_comma_separator: () => formatWithDelimiters(cents, precision, ".", ","),
      amount_no_decimals_with_comma_separator: () => formatWithDelimiters(cents, 0, ".", ","),
      amount_with_apostrophe_separator: () => formatWithDelimiters(cents, precision, "'", "."),
      amount_with_space_separator: () => formatWithDelimiters(cents, precision, " ", ","),
      amount_with_period_and_space_separator: () => formatWithDelimiters(cents, precision, " ", ".")
    }[placeholder];
    return MONEY_FORMAT.replace(/\{\{\s*\w+\s*\}\}/, value ? value() : formatWithDelimiters(cents, 2));
  }

  /* ---------- cabecera pegajosa ---------- */
  const header = $("[data-header]");
  const onScroll = () => header && header.classList.toggle("is-stuck", window.scrollY > 8);
  onScroll();
  window.addEventListener("scroll", onScroll, { passive: true });

  /* ---------- menú móvil ---------- */
  const menuBtn = $("[data-menu]");
  const menuPanel = $("[data-menu-panel]");
  if (menuBtn && menuPanel) {
    const setMenu = (open) => {
      menuBtn.setAttribute("aria-expanded", String(open));
      menuBtn.setAttribute("aria-label", open ? "Cerrar menú" : "Abrir menú");
      menuPanel.hidden = !open;
    };
    menuBtn.addEventListener("click", () => setMenu(menuBtn.getAttribute("aria-expanded") !== "true"));
    $$("a", menuPanel).forEach((a) => a.addEventListener("click", () => setMenu(false)));
  }

  /* ---------- revelado al hacer scroll ---------- */
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const revealTargets = $$(".tile, .card, .label__card, .steps__list li, .faq__item, .more__intro, .offer");
  if ("IntersectionObserver" in window && !reduceMotion) {
    revealTargets.forEach((el) => el.classList.add("reveal"));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add("in");
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revealTargets.forEach((el) => io.observe(el));
  }

  /* ---------- secuencia de preparación ---------- */
  const stepsSection = $("[data-steps]");
  if (stepsSection) {
    if (!reduceMotion && "IntersectionObserver" in window) {
      stepsSection.classList.add("steps--armed");
      const stepObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          stepsSection.classList.add("is-live");
          stepObserver.disconnect();
        });
      }, { threshold: 0.22, rootMargin: "0px 0px -6% 0px" });
      stepObserver.observe(stepsSection);
    } else {
      stepsSection.classList.add("is-live");
    }
  }

  /* ---------- avisos ---------- */
  const toastEl = $("[data-toast]");
  let toastTimer = null;
  function notify(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("is-on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("is-on"), 2600);
  }

  /* ---------- ofertas: el pack se cobra con la variante real ---------- */
  const OFFER_CONFIGS = Array.isArray(window.DIVAS_OFFERS) ? window.DIVAS_OFFERS : [];
  const offerByHandle = (handle) => OFFER_CONFIGS.find((offer) => offer.handle === handle);
  const offerByVariant = (variantId) => OFFER_CONFIGS.find((offer) => String(offer.unitId) === String(variantId) || String(offer.packId) === String(variantId));

  function updateOffer(panel) {
    if (!panel) return;
    const pack = $("[data-packs] .pack.is-active", panel) || $("[data-packs] .pack", panel);
    if (!pack) return;

    const qty = Math.max(1, parseInt($("[data-qty-value]", panel)?.textContent, 10) || 1);
    const price = Number(pack.dataset.price) || 0;
    const compare = Number(pack.dataset.compare) || 0;
    const selectedId = String(pack.dataset.variantId);
    const config = offerByHandle(panel.dataset.panel);
    const isUnit = config && selectedId === String(config.unitId);
    const isPack = config && selectedId === String(config.packId);

    let units = qty;
    let total = price * qty;
    let listTotal = compare > price ? compare * qty : total;
    let title = (pack.dataset.title || "").toUpperCase();
    let shotId = selectedId;

    if (isUnit && qty >= 2) {
      units = qty;
      const packs = Math.floor(units / config.unitsPerPack);
      const remainder = units % config.unitsPerPack;
      total = packs * config.packPrice + remainder * config.unitPrice;
      listTotal = units * config.unitPrice;
      title = `${units} TARRO${units === 1 ? "" : "S"}`;
      shotId = String(config.packId);
    } else if (isPack) {
      units = qty * config.unitsPerPack;
      total = qty * config.packPrice;
      listTotal = qty * (compare > price ? compare : price);
      title = qty > 1 ? `${qty} × 2 TARROS` : "2 TARROS";
      shotId = String(config.packId);
    }

    $$("[data-shot]", panel).forEach((img) => {
      const on = String(img.dataset.shot) === shotId;
      img.classList.toggle("is-on", on);
      if (on) img.removeAttribute("aria-hidden");
      else img.setAttribute("aria-hidden", "true");
    });

    const add = $("[data-add]", panel);
    const available = pack.dataset.available === "true";
    if (add) {
      add.dataset.addVariant = selectedId;
      add.disabled = !available;
      add.innerHTML = available
        ? `AÑADIR ${title} · ${money(total)} <span aria-hidden="true">↗</span>`
        : `AGOTADO · ${title} <span aria-hidden="true">↗</span>`;
    }

    const ship = $("[data-ship]", panel);
    if (ship) {
      if (config && units >= 2 && panel.dataset.packShip) ship.textContent = `✓ ${panel.dataset.packShip}`;
      else if (config && panel.dataset.unitShip) ship.textContent = `• ${panel.dataset.unitShip}`;
      else if (pack.dataset.shipText) ship.textContent = pack.dataset.shipText;
    }

    const saved = listTotal - total;
    const save = $("[data-save]", panel);
    if (save) {
      save.hidden = saved <= 0;
      save.textContent = saved > 0 ? `Ahorras ${money(saved)} frente a comprar sueltos` : "";
    }
  }

  function initOffers() {
    $$("[data-offer]").forEach((panel) => {
      const active = $("[data-packs] .pack.is-active:not([disabled])", panel)
        || $("[data-packs] .pack:not([disabled])", panel)
        || $("[data-packs] .pack.is-active", panel)
        || $("[data-packs] .pack", panel);
      if (!active) return;
      $$("[data-packs] .pack", panel).forEach((b) => {
        const on = b === active;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", String(on));
      });
      updateOffer(panel);
    });
  }

  /* ---------- bolsa nativa ---------- */
  const drawer = $("[data-drawer]");
  const overlay = $("[data-overlay]");
  let lastFocus = null;

  function setCount(value) {
    $$("[data-cart-count]").forEach((el) => (el.textContent = value));
  }

  function applySections(sections) {
    const html = sections && sections["cart-drawer"];
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, "text/html");
    const body = $("[data-cart-body]", doc);
    const totals = $("[data-cart-totals]", doc);
    const count = $(".drawer__head [data-cart-count]", doc);
    if (body && $("[data-cart-body]")) $("[data-cart-body]").innerHTML = body.innerHTML;
    if (totals && $("[data-cart-totals]")) $("[data-cart-totals]").innerHTML = totals.innerHTML;
    if (count) setCount(count.textContent.trim());
    return true;
  }

  function cartEndpoint(path) {
    const url = new URL(`${path}.js`, window.location.origin);
    url.searchParams.set("sections", "cart-drawer");
    if (Shopify.country) url.searchParams.set("country", Shopify.country);
    return url.pathname + url.search;
  }

  async function cartPost(url, payload) {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(payload)
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || "No pudimos actualizar la bolsa.");
    return data;
  }

  function cartFetch() {
    const url = Shopify.country ? `/cart.js?country=${encodeURIComponent(Shopify.country)}` : "/cart.js";
    return fetch(url, { headers: { Accept: "application/json" } }).then((response) => response.json());
  }

  function syncCount() {
    return cartFetch()
      .then((cart) => setCount(cart.item_count))
      .catch(() => {});
  }

  function offerUnitsInCart(cart, config) {
    return cart.items.reduce((total, item) => {
      if (String(item.variant_id) === String(config.unitId)) return total + item.quantity;
      if (String(item.variant_id) === String(config.packId)) return total + item.quantity * config.unitsPerPack;
      return total;
    }, 0);
  }

  function splitOfferUnits(config, totalUnits) {
    return {
      pack: Math.floor(totalUnits / config.unitsPerPack),
      unit: totalUnits % config.unitsPerPack
    };
  }

  // Una sola cola evita que dos clics seguidos calculen el pack sobre un carrito viejo.
  let offerQueue = Promise.resolve();
  function queueOffer(task) {
    const run = offerQueue.then(task, task);
    offerQueue = run.catch(() => {});
    return run;
  }

  // Deja el carrito con el total de tarros pedido, usando las variantes reales:
  // cada envase de 2 tarros es una unidad del pack; el resto va como tarro suelto.
  async function applyOfferTotal(config, totalUnits) {
    const cart = await cartFetch();
    const unitLine = cart.items.find((item) => String(item.variant_id) === String(config.unitId));
    const packLine = cart.items.find((item) => String(item.variant_id) === String(config.packId));
    const desired = splitOfferUnits(config, totalUnits);
    const items = [];
    const updates = {};

    if (!unitLine && desired.unit > 0) items.push({ id: Number(config.unitId), quantity: desired.unit });
    if (!packLine && desired.pack > 0) items.push({ id: Number(config.packId), quantity: desired.pack });

    if (unitLine && unitLine.quantity !== desired.unit) updates[unitLine.key] = desired.unit;
    if (packLine && packLine.quantity !== desired.pack) updates[packLine.key] = desired.pack;

    let data = null;
    if (items.length) {
      data = await cartPost(cartEndpoint(Shopify.routes.cart_add_url), { items });
      if (data && data.sections) applySections(data.sections);
    }
    if (Object.keys(updates).length) {
      data = await cartPost(cartEndpoint(Shopify.routes.cart_update_url), { updates });
      if (data && data.sections) applySections(data.sections);
    }

    if (!data) syncCount();
    return cartFetch();
  }

  let normalizing = null;
  function normalizeOffers() {
    if (normalizing) return normalizing;
    normalizing = queueOffer(async () => {
      const cart = await cartFetch();
      let changed = false;
      for (const config of OFFER_CONFIGS) {
        const total = offerUnitsInCart(cart, config);
        const unitLine = cart.items.find((item) => String(item.variant_id) === String(config.unitId));
        const packLine = cart.items.find((item) => String(item.variant_id) === String(config.packId));
        const currentPack = packLine ? packLine.quantity : 0;
        const currentUnit = unitLine ? unitLine.quantity : 0;
        const desired = splitOfferUnits(config, total);
        if (currentPack !== desired.pack || currentUnit !== desired.unit) {
          await applyOfferTotal(config, total);
          changed = true;
        }
      }
      return { cart: await cartFetch(), changed };
    }).finally(() => {
      normalizing = null;
    });
    return normalizing;
  }

  function changeOfferUnits(config, delta) {
    return queueOffer(async () => {
      const cart = await cartFetch();
      const next = Math.max(0, offerUnitsInCart(cart, config) + delta);
      await applyOfferTotal(config, next);
    });
  }

  async function addVariant(variantId, quantity = 1, name = "") {
    if (!variantId) return;
    try {
      const config = offerByVariant(variantId);
      if (config) {
        await queueOffer(async () => {
          const cart = await cartFetch();
          const current = offerUnitsInCart(cart, config);
          const added = String(variantId) === String(config.packId)
            ? quantity * config.unitsPerPack
            : quantity;
          await applyOfferTotal(config, current + added);
        });
      } else {
        const data = await cartPost(cartEndpoint(Shopify.routes.cart_add_url), {
          items: [{ id: Number(variantId), quantity }]
        });
        applySections(data.sections);
      }
      openCart();
      notify(`${name || "Producto"} en la bolsa`);
    } catch (error) {
      notify(error.message);
    }
  }

  async function changeLine(key, quantity) {
    try {
      const data = await cartPost(cartEndpoint(Shopify.routes.cart_change_url), {
        id: key,
        quantity
      });
      if (!applySections(data.sections)) syncCount();
    } catch (error) {
      notify(error.message);
    }
  }

  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("no-scroll");
    if (overlay) {
      overlay.hidden = false;
      requestAnimationFrame(() => overlay.classList.add("is-on"));
    }
    $("[data-close-cart]", drawer)?.focus({ preventScroll: true });
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-scroll");
    if (overlay) {
      overlay.classList.remove("is-on");
      setTimeout(() => {
        if (!drawer.classList.contains("is-open")) overlay.hidden = true;
      }, 300);
    }
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener("submit", (event) => {
    const quick = event.target.closest("[data-quick-add]");
    if (!quick) return;
    event.preventDefault();
    const data = new FormData(quick);
    const name = $(".pcard__title", quick.closest(".pcard"))?.textContent.trim() || "";
    addVariant(data.get("id"), Math.max(1, parseInt(data.get("quantity"), 10) || 1), name);
  });

  document.addEventListener("click", (event) => {
    const pack = event.target.closest("[data-packs] .pack");
    if (pack) {
      const panel = pack.closest("[data-offer]");
      $$("[data-packs] .pack", panel).forEach((b) => {
        const on = b === pack;
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-pressed", String(on));
      });
      updateOffer(panel);
      return;
    }

    const qtyBtn = event.target.closest("[data-qty] button");
    if (qtyBtn) {
      const qty = qtyBtn.closest("[data-qty]");
      const value = $("[data-qty-value]", qty);
      const step = qtyBtn.hasAttribute("data-qty-plus") ? 1 : -1;
      value.textContent = Math.max(1, (parseInt(value.textContent, 10) || 1) + step);
      updateOffer(qty.closest("[data-offer]"));
      return;
    }

    const add = event.target.closest("[data-add]");
    if (add) {
      const panel = add.closest("[data-offer]");
      const qty = Math.max(1, parseInt($("[data-qty-value]", panel)?.textContent, 10) || 1);
      const name = $(".offer__name", panel)?.textContent.trim() || "";
      addVariant(add.dataset.addVariant, qty, name);
      return;
    }

    const addAny = event.target.closest("[data-add-variant]");
    if (addAny) {
      addVariant(addAny.dataset.addVariant, parseInt(addAny.dataset.addQty, 10) || 1, addAny.dataset.addName || "");
      return;
    }

    const lineBtn = event.target.closest("[data-cart-qty]");
    if (lineBtn) {
      const line = lineBtn.closest("[data-cart-line]");
      const config = offerByVariant(line.dataset.variantId);
      if (config) {
        changeOfferUnits(config, parseInt(lineBtn.dataset.cartQty, 10)).catch((error) => notify(error.message));
        return;
      }
      const current = parseInt($(".cart-item__ctrl span", line)?.textContent, 10) || 0;
      changeLine(line.dataset.cartLine, Math.max(0, current + parseInt(lineBtn.dataset.cartQty, 10)));
      return;
    }

    const pageMinus = event.target.closest("[data-cart-page-minus]");
    if (pageMinus) {
      const line = pageMinus.closest("[data-cart-line]");
      const config = offerByVariant(line.dataset.variantId);
      if (config) {
        changeOfferUnits(config, -1)
          .then(() => window.location.reload())
          .catch((error) => notify(error.message));
      }
      return;
    }

    const remove = event.target.closest("[data-cart-remove]");
    if (remove) {
      const line = remove.closest("[data-cart-line]");
      changeLine(line.dataset.cartLine, 0);
      return;
    }

    if (event.target.closest("[data-open-cart]")) {
      openCart();
      return;
    }

    if (event.target.closest("[data-close-cart]")) {
      closeCart();
      return;
    }

    if (event.target.closest("[data-overlay]")) closeCart();
  });

  overlay?.addEventListener("click", closeCart);

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && drawer?.classList.contains("is-open")) closeCart();

    if (event.key === "Tab" && drawer?.classList.contains("is-open")) {
      const focusables = $$('button, [href], input, [tabindex]:not([tabindex="-1"])', drawer)
        .filter((el) => !el.disabled && el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });

  /* ---------- ficha de producto ---------- */
  function initProduct() {
    const section = $("[data-product]");
    const form = $("#product-form");
    if (!section || !form) return;

    const priceEl = $("[data-product-price]", section);
    const compareEl = $("[data-product-compare]", section);
    const saveEl = $("[data-product-save]", section);
    const stockEl = $("[data-product-stock]", section);
    const mainImage = $("[data-product-image]", section);
    const thumbs = $$("[data-thumb]", section);
    const submit = $("[data-product-submit]", form);
    const submitLabel = $("[data-product-submit-label]", form);
    const qtyInput = $("[data-product-qty-input]", form);
    const bundleEl = $("[data-product-bundle]", section);
    const soldOutLabel = submitLabel?.dataset.soldOut || "AGOTADO";
    const offerConfig = offerByHandle(section.dataset.productHandle);
    let busy = false;

    const variantInput = () => $('input[name="id"]:checked', form) || $('input[name="id"][type="hidden"]', form);

    function refreshBundle() {
      if (!bundleEl || !offerConfig) return;
      const input = variantInput();
      const qty = Math.max(1, parseInt(qtyInput?.value, 10) || 1);
      if (!input) {
        bundleEl.hidden = true;
        return;
      }
      const isUnit = String(input.value) === String(offerConfig.unitId);
      const isPack = String(input.value) === String(offerConfig.packId);
      if (isUnit && qty >= 2) {
        const packs = Math.floor(qty / offerConfig.unitsPerPack);
        const remainder = qty % offerConfig.unitsPerPack;
        const total = packs * offerConfig.packPrice + remainder * offerConfig.unitPrice;
        const saved = qty * offerConfig.unitPrice - total;
        bundleEl.hidden = false;
        bundleEl.textContent = `${qty} tarros · ${money(total)}${saved > 0 ? ` · ahorras ${money(saved)}` : ""}`;
      } else if (isPack && qty > 1) {
        const units = qty * offerConfig.unitsPerPack;
        bundleEl.hidden = false;
        bundleEl.textContent = `${units} tarros · ${money(qty * offerConfig.packPrice)}`;
      } else {
        bundleEl.hidden = true;
      }
    }

    function markThumb(src) {
      if (!src) return;
      thumbs.forEach((thumb) => {
        const on = thumb.dataset.src === src;
        thumb.classList.toggle("is-active", on);
        thumb.setAttribute("aria-pressed", String(on));
      });
    }

    function update(input, updateUrl = true) {
      if (!input) return;
      const price = Number(input.dataset.price) || 0;
      const compare = Number(input.dataset.compare) || 0;
      const available = input.dataset.available === "true";

      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        compareEl.hidden = compare <= price;
        if (compare > price) compareEl.textContent = money(compare);
      }
      if (saveEl) {
        saveEl.hidden = compare <= price;
        if (compare > price) saveEl.textContent = `Ahorras ${money(compare - price)}`;
      }
      if (stockEl) {
        stockEl.dataset.soldOut = String(!available);
        stockEl.textContent = available ? "Disponible · listo para enviar" : "Agotado por ahora";
      }
      if (submit) submit.disabled = !available || busy;
      if (submitLabel && !busy) submitLabel.textContent = available ? submit.dataset.label || "AÑADIR A LA BOLSA" : soldOutLabel;

      if (mainImage && input.dataset.image) {
        mainImage.src = input.dataset.image;
        if (input.dataset.imageSrcset) mainImage.srcset = input.dataset.imageSrcset;
        mainImage.alt = input.dataset.imageAlt || mainImage.alt;
        markThumb(input.dataset.image);
      }

      refreshBundle();

      if (updateUrl && history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", input.value);
        history.replaceState({}, "", url.toString());
      }
    }

    $$('input[name="id"]', form).forEach((input) => {
      input.addEventListener("change", () => update(input));
    });

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", () => {
        if (!mainImage) return;
        mainImage.src = thumb.dataset.src;
        if (thumb.dataset.srcset) mainImage.srcset = thumb.dataset.srcset;
        mainImage.alt = thumb.dataset.alt || mainImage.alt;
        markThumb(thumb.dataset.src);
      });
    });

    $$("[data-product-qty-minus], [data-product-qty-plus]", form).forEach((button) => {
      button.addEventListener("click", () => {
        if (!qtyInput) return;
        const current = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        qtyInput.value = button.hasAttribute("data-product-qty-plus") ? current + 1 : Math.max(1, current - 1);
        refreshBundle();
      });
    });

    qtyInput?.addEventListener("change", () => {
      qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      refreshBundle();
    });

    form.addEventListener("submit", async (event) => {
      if (busy) {
        event.preventDefault();
        return;
      }
      const input = variantInput();
      if (!input || input.dataset.available !== "true") return;

      event.preventDefault();
      busy = true;
      const label = submitLabel?.textContent;
      if (submit) submit.disabled = true;
      if (submitLabel) submitLabel.textContent = "AÑADIENDO…";

      try {
        const productName = $(".product__info h1", section)?.textContent.trim() || "Producto";
        await addVariant(input.value, Math.max(1, parseInt(qtyInput?.value, 10) || 1), productName);
        if (qtyInput) qtyInput.value = 1;
        refreshBundle();
      } catch (error) {
        notify(error.message);
      } finally {
        busy = false;
        if (submitLabel && label) submitLabel.textContent = label;
        if (submit && input.dataset.available === "true") submit.disabled = false;
      }
    });

    const initial = variantInput();
    if (initial) update(initial, false);
  }

  /* ---------- barra móvil ---------- */
  $("[data-mobile-bar]")?.classList.add("is-on");

  /* ---------- orden de colecciones ---------- */
  $$("[data-sort-select]").forEach((select) => {
    select.addEventListener("change", () => select.form?.submit());
  });

  /* ---------- bolsa: actualizar y checkout con packs normalizados ---------- */
  const cartPageForm = $(".cartpage__form");
  if (cartPageForm) {
    cartPageForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submitter = event.submitter || document.activeElement;
      const updates = {};
      const targets = new Map();
      $$("[data-cart-line]", cartPageForm).forEach((line) => {
        const input = $('input[name="updates[]"]', line);
        if (!input) return;
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        if (line.dataset.cartLine) updates[line.dataset.cartLine] = qty;
        const config = offerByVariant(line.dataset.variantId);
        if (!config) return;
        const units = String(line.dataset.variantId) === String(config.packId)
          ? qty * config.unitsPerPack
          : qty;
        targets.set(config.handle, (targets.get(config.handle) || 0) + units);
      });

      try {
        const data = await cartPost(cartEndpoint(Shopify.routes.cart_update_url), { updates });
        applySections(data.sections);
        // El total se calcula con lo que el cliente acaba de escribir, no con una
        // lectura que puede llegar un instante antes de que Shopify confirme el cambio.
        for (const config of OFFER_CONFIGS) {
          if (targets.has(config.handle)) await applyOfferTotal(config, targets.get(config.handle));
        }
        if (submitter && submitter.name === "checkout") {
          window.location.href = Shopify.country ? `/checkout?country=${encodeURIComponent(Shopify.country)}` : "/checkout";
        } else {
          window.location.reload();
        }
      } catch (error) {
        notify(error.message);
      }
    });
  }

  /* ---------- checkout: la bolsa ya está normalizada antes de salir ---------- */
  document.addEventListener("submit", async (event) => {
    const submitter = event.submitter;
    const form = event.target;
    if (!submitter || submitter.name !== "checkout" || !form.closest("[data-drawer]")) return;
    event.preventDefault();
    if (submitter.disabled) return;
    submitter.disabled = true;
    try {
      await queueOffer(() => {});
      await normalizeOffers();
      window.location.href = Shopify.country
        ? `/checkout?country=${encodeURIComponent(Shopify.country)}`
        : "/checkout";
    } catch (error) {
      submitter.disabled = false;
      notify(error.message);
    }
  });

  /* ---------- WhatsApp flotante: contraste con el fondo que pasa detrás ---------- */
  const waFloat = $(".wa-float");
  if (waFloat && document.elementsFromPoint) {
    let waPending = false;
    let waLast = 0;

    const waChannel = (value) => {
      const c = value / 255;
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    };
    const waLuminance = (r, g, b) => 0.2126 * waChannel(r) + 0.7152 * waChannel(g) + 0.0722 * waChannel(b);
    const waContrast = (a, b) => (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);

    // Colores de marca reales, para elegir siempre la pareja de más contraste.
    const waRootStyle = getComputedStyle(document.documentElement);
    const waHex = (value, fallback) => {
      const match = (value || "").trim().match(/^#([0-9a-f]{6})$/i);
      if (!match) return fallback;
      const n = parseInt(match[1], 16);
      return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
    };
    const waAcid = waHex(waRootStyle.getPropertyValue("--acid"), { r: 199, g: 250, b: 47 });
    const waInk = waHex(waRootStyle.getPropertyValue("--ink"), { r: 11, g: 11, b: 7 });
    const waAcidL = waLuminance(waAcid.r, waAcid.g, waAcid.b);
    const waInkL = waLuminance(waInk.r, waInk.g, waInk.b);
    const waParse = (value) => {
      const match = value && value.match(/rgba?\(([^)]+)\)/);
      if (!match) return null;
      const parts = match[1].split(",").map((part) => parseFloat(part));
      return { r: parts[0], g: parts[1], b: parts[2], a: parts.length > 3 ? parts[3] : 1 };
    };

    // Cada foto se mide una vez: miniatura de 24×24 que luego se consulta por zona.
    const PHOTO_SIZE = 24;
    const waPhotos = new Map();
    const waPhotoSheet = (img) => {
      const url = img.currentSrc || img.src;
      if (!url) return null;
      if (waPhotos.has(url)) return waPhotos.get(url);
      waPhotos.set(url, null);
      const probe = new Image();
      probe.crossOrigin = "anonymous";
      probe.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = PHOTO_SIZE;
          canvas.height = PHOTO_SIZE;
          const context = canvas.getContext("2d", { willReadFrequently: true });
          context.drawImage(probe, 0, 0, PHOTO_SIZE, PHOTO_SIZE);
          waPhotos.set(url, context.getImageData(0, 0, PHOTO_SIZE, PHOTO_SIZE));
        } catch (error) {
          waPhotos.set(url, -1);
        }
        waSchedule();
      };
      probe.onerror = () => waPhotos.set(url, -1);
      probe.src = url;
      return null;
    };

    // Zona de la foto que queda justo detrás del botón (object-fit centrado).
    const waPhotoTone = (img, x, y) => {
      const sheet = waPhotoSheet(img);
      if (!sheet || sheet === -1) return null;
      const rect = img.getBoundingClientRect();
      const naturalW = img.naturalWidth;
      const naturalH = img.naturalHeight;
      if (!rect.width || !rect.height || !naturalW || !naturalH) return null;

      const scalex = rect.width / naturalW;
      const scaley = rect.height / naturalH;
      const fit = getComputedStyle(img).objectFit || "fill";
      let sx = scalex;
      let sy = scaley;
      let offsetX = 0;
      let offsetY = 0;
      if (fit === "cover" || fit === "contain") {
        const scale = fit === "cover" ? Math.max(scalex, scaley) : Math.min(scalex, scaley);
        sx = scale;
        sy = scale;
        offsetX = (rect.width - naturalW * scale) / 2;
        offsetY = (rect.height - naturalH * scale) / 2;
      } else if (fit === "none") {
        sx = 1;
        sy = 1;
        offsetX = (rect.width - naturalW) / 2;
        offsetY = (rect.height - naturalH) / 2;
      }

      const u = (x - rect.left - offsetX) / (naturalW * sx);
      const v = (y - rect.top - offsetY) / (naturalH * sy);
      if (u < 0 || u > 1 || v < 0 || v > 1) return null;

      const cx = Math.min(PHOTO_SIZE - 1, Math.max(0, Math.floor(u * PHOTO_SIZE)));
      const cy = Math.min(PHOTO_SIZE - 1, Math.max(0, Math.floor(v * PHOTO_SIZE)));
      let sum = 0;
      let count = 0;
      for (let dy = -1; dy <= 1; dy += 1) {
        for (let dx = -1; dx <= 1; dx += 1) {
          const px = cx + dx;
          const py = cy + dy;
          if (px < 0 || py < 0 || px >= PHOTO_SIZE || py >= PHOTO_SIZE) continue;
          const i = (py * PHOTO_SIZE + px) * 4;
          sum += waLuminance(sheet.data[i], sheet.data[i + 1], sheet.data[i + 2]);
          count += 1;
        }
      }
      return count ? sum / count : null;
    };

    // Luminancia de lo que se ve en un punto de la pantalla.
    const waToneAt = (x, y) => {
      for (const el of document.elementsFromPoint(x, y)) {
        if (el === waFloat || waFloat.contains(el)) continue;
        if (el.tagName === "IMG") {
          const tone = waPhotoTone(el, x, y);
          if (tone !== null) return tone;
          const color = waParse(getComputedStyle(el).backgroundColor);
          if (color && color.a >= 0.75) return waLuminance(color.r, color.g, color.b);
          return null; // foto sin medir: mejor no adivinar
        }
        const color = waParse(getComputedStyle(el).backgroundColor);
        if (color && color.a >= 0.75) return waLuminance(color.r, color.g, color.b);
      }
      return null;
    };

    const waMeasure = () => {
      const rect = waFloat.getBoundingClientRect();
      const left = rect.left - 10;
      const right = Math.min(rect.right - 10, window.innerWidth - 1);
      const probes = [
        [left, rect.top + rect.height * 0.25],
        [left, rect.top + rect.height * 0.5],
        [left, rect.top + rect.height * 0.75],
        [rect.left + rect.width * 0.25, rect.top - 8],
        [rect.left + rect.width * 0.5, rect.top - 8],
        [right, rect.top - 8],
        [rect.left + rect.width * 0.5, rect.bottom + 8]
      ];
      const tones = [];
      for (const [x, y] of probes) {
        if (x < 0 || y < 0 || x > window.innerWidth || y > window.innerHeight) continue;
        const tone = waToneAt(x, y);
        if (tone !== null) tones.push(tone);
      }
      if (!tones.length) return; // sin datos fiables se mantiene el tono actual
      tones.sort((a, b) => a - b);
      // Mediana: un detalle oscuro suelto no cambia el color del botón.
      const middle = tones[Math.floor(tones.length / 2)];
      const acidWins = waContrast(waAcidL, middle) >= waContrast(waInkL, middle);
      waFloat.dataset.tone = acidWins ? "acid" : "ink";
    };

    // Una medición cada 100 ms como máximo: sigue el scroll sin coste perceptible.
    const waSchedule = () => {
      if (waPending) return;
      waPending = true;
      const wait = Math.max(0, 100 - (performance.now() - waLast));
      window.setTimeout(() => {
        window.requestAnimationFrame(() => {
          waPending = false;
          waLast = performance.now();
          waMeasure();
        });
      }, wait);
    };

    waMeasure();
    window.addEventListener("scroll", waSchedule, { passive: true });
    window.addEventListener("resize", waSchedule);
    window.addEventListener("load", waSchedule);
    window.setTimeout(waSchedule, 800);
    if ("ResizeObserver" in window) new ResizeObserver(waSchedule).observe(document.body);
  }

  /* ---------- arranque ---------- */
  normalizeOffers()
    .then(({ changed }) => {
      if (changed && $(".cartpage__form")) window.location.reload();
    })
    .catch(() => {});
  initOffers();
  initProduct();
})();
